export enum Hcc {
    MAHCCV242022_FINAL = "MA HCC V24 - 2022 Final",
    MAHCCV242023 = "MA HCC V24 - 2023",
    MAHCCV24 = "MA HCC V24",
}
